export function AppAlert({
    type,
    message,
} = {}) {
    return {
        type,
        message,
    };
}